/* Freyen drawer: reuse Avone's cart renderer and Shopify's existing free-gift SKU. */
(() => {
  let timer, pending, rerun = false;
  const reward = () => document.querySelector('freyen-cart-rewards');
  const goal = () => {
    const currency = window.Shopify?.currency;
    if (currency?.active && currency.active !== 'EUR' && !Number(currency.rate)) return null;
    return Math.round(Number(reward()?.dataset.goal || 18000) * Number(currency?.rate || 1));
  };
  const spend = cart => cart.total_price - cart.items.filter(item => item.handle === 'shoes-care-kit-copy').reduce((sum, item) => sum + item.final_line_price, 0);
  const show = cart => {
    const element = reward(), threshold = goal();
    if (!element || !threshold) return;
    const amount = Math.max(0, threshold - spend(cart));
    const progress = 50 + Math.min(50, spend(cart) / threshold * 50);
    const track = element.querySelector('.freyen-cart-rewards__track');
    track.setAttribute('aria-valuenow', Math.round(progress));
    track.classList.toggle('is-complete', amount === 0);
    track.querySelector('span').style.width = `${progress}%`;
    track.querySelector('i:last-child').textContent = '✓';
    const fallbackMoney = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:cart.currency}).format(amount / 100);
    const money = cart.currency === window.theme?.shopCurrency && window.theme?.Currency?.formatMoney ? new DOMParser().parseFromString(window.theme.Currency.formatMoney(amount, window.theme.moneyFormat), 'text/html').body.textContent : fallbackMoney;
    element.querySelector('.freyen-cart-rewards__message').textContent = amount === 0 ? element.dataset.unlocked : element.dataset.remaining.replace('__AMOUNT__', money);
  };
  async function reconcile() {
    if (pending) { rerun = true; return pending; }
    pending = (async () => {
      const element = reward(), threshold = goal();
      if (!element || !threshold) return;
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Unable to read cart');
      const cart = await response.json();
      show(cart);
      const gifts = cart.items.filter(item => item.handle === 'shoes-care-kit-copy');
      const eligible = spend(cart) >= threshold && element.dataset.available === 'true' && element.dataset.free === 'true';
      const updates = {};
      if (eligible && !gifts.length) updates[element.dataset.gift] = 1;
      gifts.forEach((gift, index) => {
        const quantity = eligible && index === 0 ? 1 : 0;
        if (gift.quantity !== quantity) updates[gift.key] = quantity;
      });
      if (!Object.keys(updates).length) return;
      const drawer = document.querySelector('cart-drawer');
      const opened = drawer.classList.contains('active');
      const scroll = drawer.querySelector('.drawer__inner').scrollTop;
      const result = await fetch(`${root}cart/update.js`, {
        method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({updates, sections:drawer.getSectionsToRender().map(section => section.id), sections_url:location.pathname})
      });
      const updated = await result.json();
      if (!result.ok || updated.status) throw new Error(updated.description || 'Unable to update gift');
      drawer.classList.toggle('is-empty', updated.item_count === 0);
      drawer.renderContents(updated);
      const count = document.querySelector('#CartCount');
      if (count) count.textContent = updated.item_count;
      setTimeout(() => {
        drawer.querySelector('.drawer__inner').scrollTop = scroll;
        if (!opened) drawer.close();
      }, 0);
    })().catch(error => {
      console.warn('Freyen gift update:', error.message);
      throw error;
    }).finally(() => {
      pending = null;
      if (rerun) { rerun = false; schedule(); }
    });
    return pending;
  }
  const schedule = () => { clearTimeout(timer); timer = setTimeout(() => reconcile().catch(() => {}), 200); };
  customElements.define('freyen-cart-rewards', class extends HTMLElement {
    connectedCallback() {
      try { show(JSON.parse(this.querySelector('.freyen-cart-state').textContent)); } catch (_) {}
      schedule();
    }
  });
  customElements.define('freyen-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      const list = this.querySelector('.freyen-cart-upsell__list');
      const track = this.querySelector('.freyen-cart-upsell__track');
      const thumb = track.querySelector('span');
      const update = () => {
        const ratio = Math.min(1, list.clientWidth / list.scrollWidth);
        track.hidden = ratio >= 1;
        thumb.style.width = `${ratio * 100}%`;
        thumb.style.left = `${list.scrollLeft / Math.max(1, list.scrollWidth - list.clientWidth) * (1 - ratio) * 100}%`;
      };
      list.addEventListener('scroll', update, {passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(list);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
  let checkoutReady = false;
  document.addEventListener('click', async event => {
    if (!event.target.closest('#CartDrawer-Checkout') || checkoutReady) return;
    event.preventDefault();
    try {
      clearTimeout(timer);
      await reconcile();
      checkoutReady = true;
      document.querySelector('#CartDrawer-Checkout')?.click();
    } catch (_) {
      const message = document.querySelector('#CartDrawer-CartErrors');
      if (message) message.textContent = document.querySelector('freyen-cart-rewards')?.dataset.error || 'Please try again.';
    } finally { checkoutReady = false; }
  }, true);
})();
